/**
 * @file Identity Filter for PPD Purchase.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';

import IdentityFilterButton from './IdentityFilterButton';
import Button from '../global/Button';
import { getAsset } from '../../util/assets';
import { getSelectedIdentityPurchasedCustomPrints } from '../../util/ppd-purchase';
import CustomPrintIcon from './custom-prints/CustomPrintIcon';
import { getIdentityMergedMatchedPhotos } from '../../util/purchase-album-photos';

class PurchasePpdIdentityFilter extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    selectedIdentities: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        identity: PropTypes.shape({
          name: PropTypes.string,
        }),
        entitled_matched_photos: PropTypes.shape({
          total: PropTypes.number,
          records: PropTypes.arrayOf(
            PropTypes.shape({
              id: PropTypes.string,
              thumbnail_urls: PropTypes.arrayOf(
                PropTypes.shape({
                  width: PropTypes.width,
                  height: PropTypes.height,
                  url: PropTypes.string,
                }),
              ),
            }),
          ),
        }),
        matched_photos: PropTypes.shape({
          total: PropTypes.number,
        }),
      }),
    ),
    activeIdentity: PropTypes.shape({
      id: PropTypes.string,
    }),
    album: PropTypes.shape({
      id: PropTypes.string,
    }),
    selectIdentity: PropTypes.func.isRequired,
    pendingPurchasedCustomPrints: PropTypes.arrayOf(PropTypes.object),
  };

  render() {
    const {
      selectedIdentities,
      activeIdentity,
      selectIdentity,
      loading,
      album,
      pendingPurchasedCustomPrints,
    } = this.props;

    if (loading || !selectedIdentities) {
      return null;
    }

    return (
      <div className="horizontal-scroller mt-2 mb-1 p-0">
        {selectedIdentities.map(selectedIdentity => {
          const isActive = selectedIdentity.id === get(activeIdentity, 'id');
          const identityPendingPurchasedCustomPrints = getSelectedIdentityPurchasedCustomPrints(
            selectedIdentity,
            pendingPurchasedCustomPrints,
          );

          // TODO: This is a temporary workaround until either `matched_photos_extended`
          // returns unique photos (de-duplicated), or we resolve the issue at the root
          // and there can never be duplicate matched_photos_extended records in the
          // first place.
          // The duplication issue started happening with Time Based Matching / PUBs where
          // a few votes where being recognized as Face Match Vote Maybes and commandered
          // normally but at the same time also matched as TBM votes, resulting into
          // duplicate matches/flushes.
          const deduplicatedMatchedPhotos = getIdentityMergedMatchedPhotos(
            selectedIdentity,
          );

          return (
            <IdentityFilterButton
              key={selectedIdentity.id}
              selectedIdentity={selectedIdentity}
              isSelected={isActive}
              toggleIdentity={() =>
                selectIdentity({
                  // Avoid having the *entire* selected identity object.
                  // This because the object contains all matched photos,
                  // and this would mean that each cart item would also contain
                  // them.
                  id: selectedIdentity.id,
                  identity: selectedIdentity.identity,
                })
              }
              badgeText={get(deduplicatedMatchedPhotos, 'length') || 0}
            >
              {identityPendingPurchasedCustomPrints.length > 0 && (
                <CustomPrintIcon
                  backgroundColor="#7ace20"
                  color="#fff"
                  size={18}
                  className="identity-has-prints-icon"
                />
              )}
            </IdentityFilterButton>
          );
        })}
        <Button
          to={`/purchase/album/${album.id}/faces`}
          btnStyle="reset"
          className="ml-1 flex-shrink-0"
        >
          <img
            src={getAsset('/icon-add-face.svg')}
            alt=""
            className="mr-2"
            width="52"
            height="52"
          />
        </Button>
      </div>
    );
  }
}

export default PurchasePpdIdentityFilter;
